import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { Link } from "@/components/Atoms";
import { SefanoButton } from "@/components/Molecules/SefanoButton";
import type { PayDebtActionProps } from "./PayDebtAction.types";
import * as styles from "./PayDebtAction.styles";

export type { PayDebtActionProps } from "./PayDebtAction.types";

export const PayDebtAction = memo(function PayDebtAction({
  canPayDebt,
  label,
  to = "/billing",
  intent = "primary",
  fullWidth = false,
  size = "medium",
}: PayDebtActionProps) {
  const { t } = useTranslation("commission");

  if (!canPayDebt) {
    return <Typography sx={styles.contactOwner}>{t("contactOwner")}</Typography>;
  }

  return (
    <Box component={Link} to={to} sx={styles.actionLink(fullWidth)}>
      <SefanoButton intent={intent} size={size} fullWidth={fullWidth} sx={styles.button}>
        {label ?? t("actions.payDebt")}
      </SefanoButton>
    </Box>
  );
});
